import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'styled-components';
import { CourseOptionDisplayModuleContext } from '../../context';
import { StyledCallToAction, StyledHeading } from '../../../sharedComponents';
import { Table, OptionDisplayLayout } from '../../layouts';

export const DefaultDisplayStyle = () => {
  const { t } = useTranslation();
  const {
    section: { title, titleSize },
    showMore,
    handleShowMoreClick,
  } = useContext(CourseOptionDisplayModuleContext);

  const themeConfig = useContext(ThemeContext);
  const dStyles = themeConfig.module.dStyles;
  const vStyles = themeConfig.module.vStyles;

  return (
    <div className="container">
      <StyledHeading
        content={title}
        as={titleSize}
        visualStyles={vStyles}
        displayStyles={dStyles}
      />

      <div className="visible-md visible-lg">
        <Table />
      </div>

      <div className="visible-xs visible-sm">
        <OptionDisplayLayout />
      </div>

      {showMore && (
        <StyledCallToAction
          displayStyles={dStyles}
          visualStyles={vStyles}
          size="medium"
          label={t('site.modules.course-option-display.cta.show-more.label')}
          onClick={handleShowMoreClick}
        />
      )}
    </div>
  );
};
